// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateVendorRequest
 */
export interface UpdateVendorRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorRequest
     */
    contact_email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorRequest
     */
    contact_name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorRequest
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorRequest
     */
    type?: string;
}

/**
 * Check if a given object implements the UpdateVendorRequest interface.
 */
export function instanceOfUpdateVendorRequest(value: object): value is UpdateVendorRequest {
    return true;
}

export function UpdateVendorRequestFromJSON(json: any): UpdateVendorRequest {
    return UpdateVendorRequestFromJSONTyped(json, false);
}

export function UpdateVendorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateVendorRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contact_email': json['contact_email'] == null ? undefined : json['contact_email'],
        'contact_name': json['contact_name'] == null ? undefined : json['contact_name'],
        'name': json['name'] == null ? undefined : json['name'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function UpdateVendorRequestToJSON(json: any): UpdateVendorRequest {
    return UpdateVendorRequestToJSONTyped(json, false);
}

export function UpdateVendorRequestToJSONTyped(value?: UpdateVendorRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact_email': value['contact_email'],
        'contact_name': value['contact_name'],
        'name': value['name'],
        'notes': value['notes'],
        'type': value['type'],
    };
}
